import { defaultLanguageCode } from '../config/variables';
import { convertMessagesForIntl } from '../Helpers/Converter';
import { formatMessage } from '../Localization/formatMessage';
import Messages from '../Localization/Messages';
import translations from '../Localization/translations/translations.json';

export const getDefaultBreadcrumbs = () => {
  return [
    {
      trackingName: 'salesAgent',
      link: '/',
      title: formatMessage(Messages.breadcrumb_searchPage),
    },
  ];
};

const messages = {
  en: convertMessagesForIntl(Messages, x => x.defaultMessage),
  sv: convertMessagesForIntl(translations, x => x.langs.sv),
  da: convertMessagesForIntl(translations, x => x.langs.da),
};

export const getLocaleInfo = () => {
  return {
    locale: defaultLanguageCode,
    messages: messages[defaultLanguageCode],
  };
};
